<template>
    <b-card no-body>
        <b-modal id="modal-approval-configuration" :title="editing ? 'Onay Kuralı Güncelle' : 'Yeni Onay Kuralı Ekle'" size="lg" no-close-on-backdrop>
            <approval-configuration-form v-model="editedItem" :errors="errors" />
            <template #modal-footer>
                <v-executer :loading="loading" :action="save" :text="editing ? 'Güncelle' : 'Oluştur'"/>
            </template>
        </b-modal>

        <v-table ref="table" :fields="fields" :items-provider="provider" :add-callback="createNew" :buttons="buttons" pagination="server" search></v-table>
    </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue";
import EmployeeOperationsApi from "@/api/employee-operations";
import ApprovalConfigurationForm from "./components/ApprovalConfigurationForm.vue";

export default {
    name: "ApprovalConfiguration",
    components: {
        BCard,
        ApprovalConfigurationForm,
    },
    data() {
        return {
            loading: false,
            editing: false,
            errors: {},
            fields: [
                { name: "Onaylayan Kullanıcı", key: "UserFullName",thClass:'w-34'},
                { name: "Alt Limit (TL)", key: "LessThan", tdClass: "text-right",thClass:'w-33'},
                { name: "Üst Limit (TL)", key: "GreaterThan", tdClass: "text-right",thClass:'w-33'},
            ],
            buttons: [
                { text: "Düzenle", key: "edit", icon: "Edit2Icon", variant: "secondary", action: this.edit },
                { text: "Sil", key: "delete", icon: "TrashIcon", variant: "danger", action: this.deleteItem },
            ],
            editedItem: {
                id: null,
                min: 0,
                max: null,
                approverUserId: null,
                userIdsToInform: [],
            },
        };
    },
    methods: {
        provider(data) {
            return EmployeeOperationsApi.TrafficFine.ApprovalConfiguration.Table(data)
                .then((response) => {
                    if (response.data.Success && response.data.Data?.Data) {
                        response.data.Data.Data = response.data.Data.Data.map((item) => ({
                            ...item,
                            GreaterThan: item.GreaterThan || "∞",
                        }));
                    }
                    return response;
                })
                .catch((err) => {
                    return err.response;
                });
        },
        clearForm() {
            this.editing = false;
            this.editedItem = {
                id: null,
                min: 0,
                max: null,
                approverUserId: null,
                userIdsToInform: [],
            };
        },
        createNew() {
            this.clearForm();
            this.$bvModal.show("modal-approval-configuration");
        },
        edit(item) {
            this.clearForm();
            this.editing = true;
            this.editedItem.id = item.Id;
            this.editedItem.min = item.LessThan;
            this.editedItem.max = item.GreaterThan;
            this.editedItem.Deactivation = item.Deactivation;
            this.editedItem.approverUserId = item.UserId;
            this.editedItem.userIdsToInform = item.UserIdsToInform || [];
            this.$bvModal.show("modal-approval-configuration");
        },
        save() {
            this.errors = {};

            if (this.editedItem.min === null || this.editedItem.min === "") {
                this.$set(this.errors, "min", "Alt limit zorunludur.");
                return;
            }

            if (this.editedItem.max !== null && this.editedItem.max !== "" && this.editedItem.max <= this.editedItem.min) {
                this.$set(this.errors, "max", "Üst limit, alt limitten büyük olmalıdır.");
                return;
            }

            const payload = {
                ...this.editedItem,
                max: this.editedItem.max === "" ? null : this.editedItem.max,
            };

            this.loading = true;
            EmployeeOperationsApi.TrafficFine.ApprovalConfiguration.CreateOrUpdate(this.editing, payload)
                .then((response) => {
                    if (response.data.Success) {
                        this.$refs.table.refresh();
                        this.$bvModal.hide("modal-approval-configuration");
                    }
                    this.$result(response);
                })
                .catch((err) => {
                    this.$result(null, err);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        deleteItem(item) {
            this.$confirm("Onay Kuralını Sil", "Onay kuralını silmek istediğinize emin misiniz? Bu işlem geri alınamaz.").then((result) => {
                if (result) {
                    EmployeeOperationsApi.TrafficFine.ApprovalConfiguration.Delete(item.Id)
                        .then((response) => {
                            if (response.data.Success) {
                                this.$refs.table.refresh();
                            }
                            this.$result(response);
                        })
                        .catch((err) => {
                            this.$result(null, err);
                        });
                }
            });
        },
    },
};
</script>
